/* eslint-disable no-unused-vars */
import { memo } from 'react';
import { useSignal, useSignalEffect } from '@preact/signals-react';
import { useSelector, useDispatch } from 'react-redux';
import { campaignReportsActions } from 'store/actions';
import { CampaignReportsCalendar } from './campaignReportsCalendar/CampaignReportsCalendar';
import { IconButton } from 'components';
import { ChartIcon } from 'assets/icons';

import * as S from './CampaignReportsHeader.styled';

export const CampaignReportsHeader = memo(({ dateRangeName$, dateFrom$, dateTo$ }) => {
  const isChartHidden = useSelector((state) => state.campaignReports.isChartHiddenCampaignReports);
  const isChartDisabled = useSelector(
    (state) => state.campaignReports.isChartDisabledCampaignReports,
  );

  const dispatch = useDispatch();

  const numOfDays =
    dateFrom$.value && dateTo$.value ? getNumOfDays(dateFrom$.value, dateTo$.value) : 0;

  return (
    <S.Header>
      <S.Title>Campaign Report</S.Title>
      <CampaignReportsCalendar
        dateFrom$={dateFrom$}
        dateTo$={dateTo$}
        dateRangeName$={dateRangeName$}
      />
      <IconButton.NormalSize
        disabled={numOfDays > 180 || numOfDays < 2 || isChartDisabled}
        icon={ChartIcon}
        isPressed={!isChartHidden}
        type={IconButton.btnTypes.tertiary}
        onClick={() => {
          dispatch(
            campaignReportsActions.updateProperty({
              propField: 'isChartHiddenCampaignReports',
              newValue: !isChartHidden,
            }),
          );
        }}
      />
    </S.Header>
  );
});

function getNumOfDays(from, to) {
  const fromDate = new Date(from);
  const toDate = new Date(to);

  return Math.floor((toDate - fromDate) / (24 * 60 * 60 * 1000)) + 1;
}

CampaignReportsHeader.displayName = 'CampaignReportsHeader';
